import { Component, Input, OnInit, Inject, OnDestroy } from '@angular/core';
import { PlayHistoryService } from '../../../_service/history/play-history.service';
import { ToastService } from '../../../_service/toast/toast.service';
import { ConfirmDialogService, ConfirmDialogState } from '../../dialogs/confirm-dialog/confirm-dialog.service';
import { DnDialogService } from '../../../_modules/dn-dialog/dn-dialog.service';
import {  Unsubscribable } from 'rxjs';
import { UserService } from '../../../_service/user/user.service';


@Component({
  selector: 'app-dropdown-history',
  templateUrl: './dropdown-history.component.html',
  styleUrls: ['./dropdown-history.component.scss']
})
export class DropdownHistoryComponent implements OnInit, OnDestroy {
  subscriptions: Array<Unsubscribable> = [];
  user;

  @Input()
  data: any;

  browsingHistory = [];

  constructor(
    private _playHistoryService: PlayHistoryService,
    private _toastService: ToastService,
    private _confirmDialogService: ConfirmDialogService,
    private _dnDialogService: DnDialogService,
    private _userService:UserService
    // @Inject(AppStore) private store: Store<UsersState>,
  ) {

  }

  ngOnInit() {


    this.user = this._userService.user;
    this.subscriptions.push(
    this._userService.userState$.subscribe(p=>{
      this.user = p;
     // console.log("2")
      this.readState();
    }),
    this._playHistoryService.playHistoryStatusSource$.subscribe(p=>{
      //console.log("1")
      if(p === true) ///从服务器调取
      {
        this._playHistoryService.lastKey = null;
        this.readState();
      }
      // else{ ///稍微提升一点体验
      //   var finded = this.browsingHistory.find(d=>d.id == p.id );
      //   if(!!finded)
      //   {
         
      //   }
      //   else
      //   {
      //     this.browsingHistory = [...p].concat(this.browsingHistory).slice(0,10);
      //   }
      // }
      // console.log(this.browsingHistory)

    })
    )

  }

  readState() {
    
    if(this.user.id>0)
    {
      this._playHistoryService.getRemotePlayHistory(
        this.user, 1, 10, "time", true, undefined, undefined, undefined)
        .subscribe(res => {
          this.browsingHistory = res.items;
        });
    }
    else
    {
      this.browsingHistory = [];
    }
   
    
  }

  clearLocalHistory() {
    this._playHistoryService.clearLocalPlayHistory();
  }

  clearHistory() {
    if (!this.browsingHistory.length) {
      return;
    }

    const confirmFormId = 'delete-address';
    const dialogId = 'confirm-dialog';

    this._confirmDialogService.setState(
      {
        id: confirmFormId,
        message: '<h5>将清除全部播放记录，确定要继续吗？</h5>',
        showIcon: false,
        state: ConfirmDialogState.Unknown
      });

    this._dnDialogService.open(dialogId);
    this._confirmDialogService.confirmDialogSource$.subscribe(r => {
      if (r.state === ConfirmDialogState.Confirmed && r.id === confirmFormId) {
        this._dnDialogService.close(dialogId);
        if (this.user && this.user.id) {
          this._playHistoryService.clearRemotePlayHistory(this.user).subscribe(() => {
            this.clearLocalHistory();
            this._playHistoryService.changePlayHistoryStatus(true);
            this._toastService.showBlackToast('已清空！');
            this.browsingHistory = [];
          });
        } else {
          this.clearLocalHistory();
          this._playHistoryService.changePlayHistoryStatus(true);
          this._toastService.showBlackToast('已清空！');
          this.browsingHistory = [];
        }
      }
      if (r.state === ConfirmDialogState.Cancalled && r.id === confirmFormId) {
        this._dnDialogService.close(dialogId);
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  timeStampSubstr(str) {
    return !!str ? str.substr(0, 10) : '';
  }
}
